// extracted by mini-css-extract-plugin
module.exports = {"total":"InvoiveRecord_total__1__f8","notInvoicedStyle":"InvoiveRecord_notInvoicedStyle__3KB6e"};